namespace $.$$ {
	export class $shm_hitalama_chat extends $.$shm_hitalama_chat {

		profile() {
			return this.$.$shm_hitalama_profile.current()!
		}
		
		draft( next?: string ): string {
			return this.profile().agent_chat_options().draft_message(next) ?? ''
		}

		messages() {
			const list = this.profile().agent_chat_room().Messages()?.remote_list() ?? []
			new this.$.$mol_after_frame( ()=> {
				this.Body().dom_node().scrollTop = this.Body().dom_node().scrollHeight
			} )
			return list.map( m => this.Message( m.link() ) )
		}

		@ $mol_mem_key
		message_text( ref: $giper_baza_link ): string {
			const m = $giper_baza_glob.Pawn( ref, $shm_hitalama_chat_message )
			return m.text()
		}

		@ $mol_mem_key
		message_author( ref: $giper_baza_link ): string {
			const m = $giper_baza_glob.Pawn( ref, $shm_hitalama_chat_message )
			return m.author()
		}

		@ $mol_mem_key
		message_date( ref: $giper_baza_link ): string {
			const m = $giper_baza_glob.Pawn( ref, $shm_hitalama_chat_message )
			return new $mol_time_moment( m.time() ).toString( 'YYYY-MM-DD hh:mm:ss' )
		}

		send( next?: any ) {
			const message = this.profile().agent_chat_room().send( this.draft() )
			this.draft('')
			this.answer( message )
		}

		answer( m: $shm_hitalama_chat_message ) {
			let matched
			for (const key in this.commands()) {
				if( m.text().startsWith( key ) ) {
					matched = key
					break
				}
			}

			if( matched ) {
				const func = (this.commands() as any)[ matched ]?.func
				func?.( m.text() )
			} else {
				this.profile().agent_chat_room().send_ai( 'Команда не распознана' )
			}
		}

		logs_clear( next?: any ) {
			const land = this.$.$giper_baza_glob.land_grab( [[ null, $giper_baza_rank_deny ]] )
			const room = land.Data( $shm_hitalama_chat_room )
			room.Messages(null)
			this.profile().Agent_chat_room(null)?.remote( room )!
			// this.profile().agent_chat_room().Messages(null)?.remote_list( [] )
		}

		commands() {
			return {
				'создай карту': {
					func: ( message: string )=> {
						const map = this.profile()?.add_map( 'Новая карта', 'private' )!
						$shm_hitalama_app.Root(0).Maps().spread( map.link().toString() )

						const json = JSON.stringify( map.serialize(), null, '  ' )
						this.profile().agent_chat_room().send_ai( 'Создана карта\n```\n'+json+'\n```' )
					},
				},
				// 'удали карту': {
				// 	func: ( message: string )=> {
				// 		const split = message.trim().split(' ')
				// 		$mol_error_fence( ()=> {
				// 			const map_link = new $giper_baza_link(split[2])
				// 			this.profile().Maps_removed(null)?.add( map_link )
				// 			this.profile()?.maps()?.cut( map_link )

				// 			const map = $giper_baza_glob.Pawn( map_link, $shm_hitalama_map )
				// 			const json = JSON.stringify( map.serialize(), null, '  ' )
				// 			this.profile().agent_chat_room().send_ai( 'Карта удалена\n```\n'+json+'\n```' )
				// 		}, ( error: any )=> {
				// 			this.profile().agent_chat_room().send_ai( error.toString() )
				// 		} )
				// 	},
				// },
				'создай виджет': {
					func: ( message: string )=> {
						const vars = extractVariables( 'создай виджет {type_name}', message.trim() )
						$mol_error_fence( ()=> {
							let type = (this.widget_titles() as any)[ vars.type_name?.toLowerCase() ]
							if( !type ) {
								const vars2 = extractVariables( 'создай виджет "{type_name}"', message.trim() )
								type = (this.widget_titles() as any)[ vars2.type_name?.toLowerCase() ]
							}
							console.log('vars', vars)
							if( !type && $shm_hitalama_map_widget_presets_item_exists( vars.type_name ) ) {
								type = vars.type_name
							}
							
							if( !type ) throw new Error(`Виджет "${vars.type_name}" не найден`);

							const map_link = new $giper_baza_link( this.$.$mol_state_arg.value( 'map' )! )
							const map = $giper_baza_glob.Pawn( map_link, $shm_hitalama_map )
							const presets = $shm_hitalama_map_widget_presets.for_map( map )

							const make_func = (presets as any)[type] || ((pos: number[]) => {
								return map.widget_add(type, pos)
							})

							const widget = make_func( [0,0] ) as $shm_hitalama_map_widget
							const serialized = map.serialize_widgets( [widget] )
							const json = JSON.stringify( serialized, null, '  ' )
							this.profile().agent_chat_room().send_ai( 'Создан виджет\n```\n'+json+'\n```' )

						}, ( error: any )=> {
							this.profile().agent_chat_room().send_ai( error.toString() )
						} )
					},
				},
				'измени текст виджета': {
					func: ( message: string )=> {
						const vars = extractVariables( 'измени текст виджета {id} на "{text}"', message.trim() )
						$mol_error_fence( ()=> {
							const widget_link = new $giper_baza_link( vars.id )
							const widget = $giper_baza_glob.Pawn( widget_link, $shm_hitalama_map_widget )
							widget.text( vars.text )

							const serialized = widget.map().serialize_widgets( [widget] )
							const json = JSON.stringify( serialized, null, '  ' )
							this.profile().agent_chat_room().send_ai( 'Текст изменен\n```\n'+json+'\n```' )

						}, ( error: any )=> {
							this.profile().agent_chat_room().send_ai( error.toString() )
						} )
					},
				},
				'смести виджет': {
					func: ( message: string )=> {
						const vars = extractVariables( 'смести виджет {id} на {px} пикселей {dir}', message.trim() )
						$mol_error_fence( ()=> {
							const widget_link = new $giper_baza_link( vars.id )
							const widget = $giper_baza_glob.Pawn( widget_link, $shm_hitalama_map_widget )

							switch (vars.dir) {
								case 'вправо': {
									widget.body_x( widget.body_x() + Number(vars.px) )
									break
								}
								case 'влево': {
									widget.body_x( widget.body_x() - Number(vars.px) )
									break
								}
								case 'вверх': {
									widget.body_y( widget.body_y() - Number(vars.px) )
									break
								}
								case 'вниз': {
									widget.body_y( widget.body_y() + Number(vars.px) )
									break
								}
								default:
									break;
							}

							const serialized = widget.map().serialize_widgets( [widget] )
							const json = JSON.stringify( serialized, null, '  ' )
							this.profile().agent_chat_room().send_ai( 'Виджет смещен\n```\n'+json+'\n```' )

						}, ( error: any )=> {
							this.profile().agent_chat_room().send_ai( error.toString() )
						} )
					},
				},
			}
		}

		widget_titles() {
			const titles = {
				... $shm_hitalama_map_widget_def_titles,
				... $shm_hitalama_map_widget_presets_def_titles,
			}
			const obj: Record< string, string > = {}
			for (const key in titles) {
				obj[ (titles as any)[ key ].toLowerCase() ] = key
			}
			return obj
		}
		
	}

	function extractVariables( template: string, inputString: string ) {
		const variableRegex = /\{([^{}]+)\}/g
		let match
		const variables = []
		let pattern = template

		while( ( match = variableRegex.exec( template ) ) !== null ) {
			const varName = match[ 1 ]
			variables.push( varName )
			pattern = pattern.replace( match[ 0 ], '(.*?)' )
		}

		const parts = pattern.split( '(.*?)' )
		const escapedParts = parts.map( part => {
			if( part === '(.*?)' ) {
				return part
			}
			return part.replace( /[/.\\+?^${}()|[\]\\]/g, '\\$&' )
		} )
		pattern = escapedParts.join( '(.*?)' )

		const regex = new RegExp( `^${ pattern }$` )

		const result = inputString.match( regex )
		if( !result ) return {}

		const output: any = {}
		variables.forEach( ( varName, index ) => {
			output[ varName ] = result[ index + 1 ]
		} )

		return output
	}
	
}
